import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSiteStatus } from '../context/SiteStatusContext';

const HotelSearchGate = () => {
  const { loading, hotelSearchEnabled } = useSiteStatus();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5FBFB]">
        <Loader2 className="w-10 h-10 text-[#659A9B] animate-spin" aria-label="Loading" />
      </div>
    );
  }

  if (!hotelSearchEnabled) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default HotelSearchGate;
